/*!
 * Product search block helper
 *
 * @package krobot
 * @deps jquery, wp-api-request
 */

const $ = jQuery;

const setCount = function( target ) {
	let curValue = parseInt( $( '#krobot-counter' ).text(), 10 );
	if ( target === curValue ) {
		// No change.
		return;
	}
	const tic = curValue > target ? -1 : 1;
	let counter = 0; // stopper.
	const timer = setInterval( function() {
		curValue += tic;
		$( '#krobot-counter' ).text( curValue );
		if ( curValue === target ) {
			clearInterval( timer );
		}
		counter++;
		if ( counter > 200 ) {
			clearInterval( timer );
			$( '#krobot-counter' ).text( target );
		}
	}, 10 );
};

$( document ).ready( function() {
	const $form = $( '.krobot-product-filter-form' );
	const postType = $form.attr( 'data-post-type' );

	const updateCount = function() {
		const query = [];
		$form.find( 'select' ).each( function( index, select ) {
			const name = $( select ).attr( 'name' );
			const val = $( select ).val();
			if ( val ) {
				query.push( `${ name }=${ val }` );
			}
		} );
		const $s = $form.find( 'input[name="ps"]' );
		if ( $s.length && $s.val().length ) {
			query.push( 'ps=' + encodeURIComponent( $s.val() ) );
		}
		wp.apiRequest( {
			path: 'krobot/v1/' + postType + '/count' + ( query.length ? ( '?' + query.join( '&' ) ) : '' ),
		} ).done( function( response ) {
			setCount( response.found );
		} ).fail( function() {
			// Do nothing.
		} );
	};

	// Pull down changes.
	$form.on( 'change', 'select', function() {
		updateCount();
	} );
} );
